import React, { useEffect, useState } from 'react';
import AceEditor from 'react-ace';
import { LuBraces } from 'react-icons/lu';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/theme-monokai';
import { Modal } from '../ui/Modal';
import { Spinner } from '../ui/Spinner';
import Alert from '../ui/Alert';
import { API_BASE_URL } from '../../config.js';

const isDarkTheme = () => document.documentElement.classList.contains('dark');

/** Read-only JSON of the dump behind the report (admin debugging). */
const RawDumpModal = ({ isOpen, onClose, clientSlug, weekId, fetchWithAuth }) => {
  const [dump, setDump] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isOpen) return undefined;
    let cancelled = false;
    const fetchDump = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetchWithAuth(`${API_BASE_URL}/api/weekly/client/${clientSlug}/week/${weekId}/dump`);
        const data = await response.json();
        if (!cancelled) setDump(data);
      } catch (err) {
        console.error('Error fetching raw dump:', err);
        if (!cancelled) setError('Impossible de charger les données brutes.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchDump();
    return () => { cancelled = true; };
  }, [isOpen, clientSlug, weekId, fetchWithAuth]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} icon={LuBraces} title="Données brutes" subtitle="Messages et fichiers récupérés pour cette semaine (lecture seule)." size="xl" fullHeight>
      {loading ? (
        <Spinner message="Chargement des données brutes…" className="flex-1" />
      ) : error ? (
        <div className="p-5"><Alert tone="danger">{error}</Alert></div>
      ) : (
        <div className="min-h-0 flex-1">
          <AceEditor
            mode="json"
            theme={isDarkTheme() ? 'monokai' : 'github'}
            name="raw-dump-editor"
            value={JSON.stringify(dump, null, 2)}
            readOnly
            width="100%"
            height="100%"
            fontSize={12}
            showPrintMargin={false}
            showGutter
            highlightActiveLine
            wrapEnabled
            setOptions={{ useWorker: false, showLineNumbers: true, tabSize: 2, wrap: true }}
          />
        </div>
      )}
    </Modal>
  );
};

export default RawDumpModal;
